import { z } from 'zod';

export const LANDING_FLOW_STORAGE_KEY = 'landing_flow';

export const LandingFlowKind = {
  videoTranscript: 'video_transcript',
} as const;

const LANDING_MEDIA_ID_PATTERN = /^[\w-]+$/;

export type LandingFlowKindType = (typeof LandingFlowKind)[keyof typeof LandingFlowKind];

export const DubLandingFlowDataSchema = z.object({
  kind: z.literal(LandingFlowKind.videoTranscript),
  media_id: z.string().regex(LANDING_MEDIA_ID_PATTERN),
  target_lang: z.string().min(1),
});

export const LandingFlowDataSchema = z.discriminatedUnion('kind', [DubLandingFlowDataSchema]);

export type DubLandingFlowData = z.infer<typeof DubLandingFlowDataSchema>;
export type LandingFlowData = z.infer<typeof LandingFlowDataSchema>;
